<template lang="pug">
  .view-control-messages
    catalog(:items="users.items" v-model="selectedUser")
      template(#item="{ item }")
        | {{ item.fullName }}

      template(#default="{ item }")
        catalog(:items="item.rooms.items" v-model="selectedRoom")
          template(#item="{ item }")
            | {{ item.prettyName }}

          template(#default="{ item }")
            resource-info(
              v-if="item.resource_type && item.resource_id"
              :resourceType="item.resource_type"
              :resourceId="item.resource_id"
            )
            messaging(:room="item")
</template>

<script>
import api from '@/api';
import User from '@/models/User';

export default {
  name: 'view-control-messages',

  data: () => ({
    users: User.collection(),
    selectedUser: null,
    selectedRoom: null,
  }),

  async created() {
    const response = await api.for(`users/rooms`).fetch();

    this.users = User.collection(response.data);
  },
};
</script>
